import type { ReactNode } from 'react'
import cx from 'classnames'
import styles from './AccessDeniedView.module.css'
import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { byDesign } from '@/infra/design'
import imgChatDisabledUrl from '@/assets/misc/img_chat-disabled.svg'
import ChatDisabledIllustration from '@/components/SpotIllustration/ChatDisabledIllustration'

interface AccessDeniedViewProps {
  title?: string
  description?: ReactNode
  /**
   * Hides the illustration, for workspaces in corporate mode.
   */
  corporateMode: boolean
  testId?: string
}

/**
 * Full-page message for users who aren't allowed to see the page.
 */
export function AccessDeniedView({
  title = 'Access Denied',
  description = 'You are not allowed to view this page. If you believe this is an error, please contact your Workspace administrator.',
  testId,
  corporateMode,
}: AccessDeniedViewProps) {
  return (
    <div className={cx(styles.root)} data-test={testId}>
      <div className={styles.box}>
        <EmptyState pad>
          {!corporateMode && (
            <EmptyStateIllustration
              src={imgChatDisabledUrl}
              illustration={byDesign(undefined, ChatDisabledIllustration)}
            />
          )}
          <EmptyStateTitle>{title}</EmptyStateTitle>
          <EmptyStateDescription>{description}</EmptyStateDescription>
        </EmptyState>
      </div>
    </div>
  )
}
